import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Breadcrumbs } from '@mui/material';
import withNotify from '../../common/withNotify';
import NotificationForm from './NotificationForm';
import { addNotification } from '../../Services/Utils/NotificationApis';
import { notifySet } from '../../Services/Actions/CommonActions';
import { fromEpochToDate } from '../../Services/config/globals';

function AddNotification() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onButtonClick = (formData) => {
    const myDate = new Date(formData.notificationEndDate);
    const myEpoch = myDate.getTime() / 1000;
    const data = {
      serviceProviderView: formData.serviceProvider,
      description: formData.notificationDescription,
      link: formData.notificationLink,
      location: formData.location,
      endDate: fromEpochToDate(myEpoch)
    };
    addNotification(data).then((res) => {
      if (res.hasError === false) {
        navigate('/notifications');
        dispatch(notifySet({ type: 'success', message: res.message }));
      } else if (res.hasError === true) {
        dispatch(notifySet({ type: 'error', message: res.message }));
      }
    });
  };

  return (
    <div className="container-fluid ">
      <div className="breadcrumb-menu-con">
        <Breadcrumbs
          separator=">"
          aria-label="breadcrumb"
        >
          <Link to="/notifications">Notifications</Link>
          <Link to="#">Add Notification</Link>
        </Breadcrumbs>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <NotificationForm
            onButtonClick={onButtonClick}
            notificationText="Add Notification"
          />
        </div>
      </div>
    </div>
  );
}

export default withNotify(AddNotification);
